import CyrillicToTranslit from 'cyrillic-to-translit-js';

// @ts-ignore
const cyrillicToTranslit = new CyrillicToTranslit();

export const transliterate = (value: string) => {
  return cyrillicToTranslit.transform(value, ' ');
};
